import { render, staticRenderFns } from "./UpdateProfileInfoStep.vue?vue&type=template&id=23d00a08&"
import script from "./UpdateProfileInfoStep.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileInfoStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports